/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Link, useLocation } from "react-router";
import { mergeSx } from "@/src/utils/mergeSx";
import { authenticatedNavigationStyle } from "@/src/components/Navigation/AuthenticatedNavigation/authenticatedNavigationStyle";
import { getCaseLink } from "@/src/services/productService";
import { Box, ListItemButton, Typography } from "@mui/material";
import { translate } from "@/src/services/translations/translations";
import { Error } from "@mui/icons-material";
import { MinimalCase } from "@/src/types/Entities/MinimalCase";
import { useBasicAccountData } from "@/src/provider/BasicAccountData/BasicAccountDataProvider";

export type AuthenticatedNavigationLinkCaseProps = {
  product: MinimalCase;
  onClose?: Function
};

export default function AuthenticatedNavigationLinkCase({ product, onClose }: AuthenticatedNavigationLinkCaseProps) {
  const location = useLocation();
  const { inquiries } = useBasicAccountData();

  const hasInquiry = !!inquiries?.find((inquiry) => inquiry.productId === product.id);

  const caseLink = getCaseLink(product);
  const isActive = (location.pathname + "/").startsWith(caseLink + "/");

  return (
    <ListItemButton
      component={Link}
      sx={mergeSx(authenticatedNavigationStyle.link, isActive && authenticatedNavigationStyle.linkActive)}
      to={caseLink}
      onClick={() => onClose?.()}
    >
      <Typography component={"span"} sx={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>
        {translate(product.name + ".label", {}, "")} {product.reference}
      </Typography>
      {hasInquiry && (
        <Box component={"span"} sx={authenticatedNavigationStyle.inquiryIcon}>
          <Error color={"warning"} />
        </Box>
      )}
    </ListItemButton>
  );
}
